import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/landing/Landing";
import Admin from "@/Admin";
import { PaymentSuccess, PaymentCancel } from "@/PaymentResult";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
